import React from 'react';
import PropTypes from 'prop-types';

const Note = ({title, description}) => (
  <div className="ph6-ns ph4">
    <h3 className="pv4" data-cy="note-title">
      {title}
    </h3>
    <p
      className="mid-gray"
      dangerouslySetInnerHTML={{
        __html: description,
      }}
      data-cy="note-description"
    />
  </div>
);

Note.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Note;
